module.exports = __webpack_public_path__ + "media/media/distributors/best_offer-4fab2fcd8c813bcd8e7d527b3350140d.png";